import { NavLink } from "react-router-dom";
import {
  MdDashboard,
  MdStorefront,
  MdCampaign,
  MdPeople,
  MdRouter,
  MdHistory,
} from "react-icons/md";

const items = [
  { to: "/superadmin/dashboard", label: "Dashboard", icon: MdDashboard },
  { to: "/superadmin/locales", label: "Locales", icon: MdStorefront },
  { to: "/superadmin/publicidad", label: "Publicidad", icon: MdCampaign },
  { to: "/superadmin/usuarios", label: "Usuarios", icon: MdPeople },
  { to: "/superadmin/nodos", label: "Nodos", icon: MdRouter },
  { to: "/superadmin/auditoria", label: "Auditoría", icon: MdHistory },
];

export default function Sidebar() {
  return (
    <aside className="w-[216px] bg-navy text-white py-5 flex flex-col border-r border-white/5">
      <div className="px-6 mb-4 text-[10px] font-mono uppercase tracking-[0.15em] text-white/35">
        Operación
      </div>
      <nav className="flex flex-col gap-0.5 px-3">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <NavLink
              key={it.to}
              to={it.to}
              className={({ isActive }) =>
                [
                  "group relative flex items-center gap-3 pl-3 pr-3 py-2.5 rounded-md text-sm transition-all duration-150",
                  isActive
                    ? "bg-white/[0.06] text-white font-medium"
                    : "text-white/50 hover:bg-white/[0.04] hover:text-white/85",
                ].join(" ")
              }
            >
              {({ isActive }) => (
                <>
                  <span
                    className={[
                      "absolute left-0 top-1/2 -translate-y-1/2 w-[3px] rounded-full bg-teal transition-all duration-200",
                      isActive ? "h-4" : "h-0 group-hover:h-2",
                    ].join(" ")}
                  />
                  <Icon size={18} className={isActive ? "text-teal" : "opacity-80"} />
                  <span>{it.label}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}
